import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";

const CloseMultipleSurveyApiService = async (
  announcementIds: number[]
): Promise<Results> => {
  const url = `/forms/close_or_delete/`;
  const { data } = await axios.post(url, { ids: announcementIds });
  return data;
};

type Results = {
  closed: number;
  deleted: number;
  ignored: number;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useCloseMultipleSurveyApiService = () =>
  useMutation<Results, AxiosError, number[]>(CloseMultipleSurveyApiService, {
    mutationKey: "CloseMultipleSurveyApiService",
  });
export default useCloseMultipleSurveyApiService;
